import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Vuex from 'vuex'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import push from 'push.js'
import xss from 'xss'

import GuestCookie from './components/guest-cookie'
import messages from './i18n'
import pageTitleNotification from '@/components/flash-title'

const flashTitle = pageTitleNotification()

dayjs.extend(utc)

Vue.use(Vuex)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'fr', // set locale
  fallbackLocale: 'en',
  messages // set locale messages
})

const _compare = (a, b) => {
  if (a.created < b.created) {
    return -1
  }
  if (a.created > b.created) {
    return 1
  }
  return 0
}

export default class {
  constructor () {
    this.state = {
      autoOpen: '',
      canType: true,
      hasZenMsgButton: false,
      helpText: null,
      inputTypeTooltip: null,
      isAllowedToPush: false,
      isLoaderSeen: false,
      isOpen: false,
      isUpload: false,
      emojiPickerShown: false,
      errors: {},
      lastEventId: null,
      messages: [],
      room: null,
      step: '', // button or chatbox or feedback
      userInfos: {
        caller: '',
        message: ''
      },
      wsIsOpen: false
    }
    this.getters = {
      autoOpen (state) {
        return state.autoOpen
      },
      caller (state) {
        return state.userInfos.caller
      },
      canType (state) {
        if (state.messages.length > 0) {
          const lastItem = state.messages[state.messages.length - 1].rich_content[
            state.messages[state.messages.length - 1].rich_content.length - 1]
          if (lastItem.kind === 'choice') {
            return false
          }
        }
        return true
      },
      hasZenMsgButton (state) {
        return state.hasZenMsgButton
      },
      inputType (state) {
        if (state.inputTypeTooltip === 'birthdate') {
          return 'date'
        } else if (state.inputTypeTooltip === 'currency' ||
                   state.inputTypeTooltip === 'int') {
          return 'number'
        } else if (state.inputTypeTooltip === 'tel') {
          return 'tel'
        }
        return 'text'
      },
      inputTypeTooltip (state) {
        return state.inputTypeTooltip
      },
      isAllowedToPush (state) {
        return state.isAllowedToPush
      },
      isEmojiPickerShown (state) {
        return state.emojiPickerShown
      },
      isLoaderSeen (state) {
        return state.isLoaderSeen
      },
      isOpen (state) {
        return state.isOpen
      },
      isUpload (state) {
        return state.isUpload
      },
      messages (state) {
        if (state.messages !== null) {
          const messages = JSON.parse(JSON.stringify(state.messages))
          return messages.sort(_compare)
        }
        return []
      },
      placeholder (state) {
        if (state.helpText !== null) {
          return state.helpText
        }
        return 'form.placeholder'
      },
      step (state) {
        return state.step
      },
      userMsg (state) {
        return state.userInfos.message
      },
      userInfos (state) {
        return state.userInfos
      },
      wsIsOpen (state) {
        return state.wsIsOpen
      }
    }
    this.actions = {
      changeStep ({ commit, state }, args) {
        commit('updateStep', args.step)
        if (args.step === 'chatbox') {
          let account = this._vm.$settings.account
          if (this._vm.$botSettings !== undefined) {
            account = this._vm.$botSettings.account
          }
          Vue.http.post(`zenchat/${account}/`, {})
        }
      },
      checkPing ({ dispatch }, args) {
        let data = []
        if ('history' in args.data) {
          data = args.data.history
        } else {
          data = args.data
          if (Array.isArray(data) === false) {
            data = [data]
          }
        }
        data.forEach((msg) => {
          // console.log('***', msg)
          if (!(msg.rich_content === null || msg.rich_content === undefined)) {
            // console.log('RICH_CONTENT')
            msg.rich_content.forEach((elt) => {
              // console.log('<<<', elt, elt.kind)
              if (elt.kind === 'ping') {
                // ping kind for waiting the bot do something async
                window.setTimeout(() => {
                  // console.log('DISPATCH PONG')
                  dispatch({
                    type: 'sendMsg',
                    content: 'pong',
                    richContent: {
                      kind: 'pong'
                    }
                  })
                }, 2000)
              }
            })
          }
        })
      },
      handleAutoOpen ({ commit, dispatch, state }) {
        let settings_ = this._vm.$settings
        if (this._vm.$botSettings !== undefined) {
          settings_ = this._vm.$botSettings
        }

        const isMobile = this._vm.$settings.ua.isMobile
        const hasBeenClosed = GuestCookie.readGuest(
          'close', settings_.account)
        // console.log('AUTO OPEN???', state.autoOpen, 'STEP', state.step,
        //   'HAS BEEN CLOSED', hasBeenClosed, 'IS MOBILE', isMobile)
        if (state.autoOpen !== '' && state.step !== 'chatbox' &&
          hasBeenClosed === null && isMobile === false) {
          try {
            const autoOpenDelay = parseInt(state.autoOpen, 10)
            if (!isNaN(autoOpenDelay)) {
              window.setTimeout(() => {
                if (state.step !== 'chatbox') {
                  dispatch({
                    type: 'changeStep',
                    step: 'chatbox'
                  })
                  dispatch({
                    type: 'initWebsocket'
                  })
                }
              }, autoOpenDelay * 1000)
            }
          } catch (e) {

          }
        }
      },
      handleMessages ({ commit, dispatch, state }, args) {
        const data = JSON.parse(args.data.data)
        if (data.cmd === 'join') {
          const guest = data.guest
          GuestCookie.storeGuest('guest', guest)
        }
        if (data.cmd === 'typing_start') {
          state.isLoaderSeen = true
        } else if (data.cmd === 'typing_end') {
          state.isLoaderSeen = false
        }
        if (data.cmd === 'join' || (data.cmd === 'event' &&
            (data.kind === 'message' || data.kind === 'bot_message' ||
             data.kind === 'gbagent_message' || data.kind === 'agent_msg' ||
             data.kind === 'zencall' || data.kind === 'form' ||
             data.kind === 'formerror' || data.kind === 'zencallerror'))) {
          commit('updateMsgs', data)
        }
        dispatch({
          type: 'checkPing',
          data: data
        })
      },
      initWebsocket ({ commit, state, dispatch, getters }) {
        if (state.wsIsOpen === false) {
          let settings_ = this._vm.$settings
          if (this._vm.$botSettings !== undefined) {
            settings_ = this._vm.$botSettings
          }
          this._vm.$socket.open(settings_.wsUrl)
          this._vm.$socket.onopen = function (e) {
            // console.error('WebSocketClient: open', arguments)
            const guestUuid = GuestCookie.readGuest('guest', settings_.account)
            // console.error('WebSocketClient open -> cookie', guestUuid)
            const params = {
              cmd: 'join',
              url: settings_.windowUrl,
              chat: settings_.account,
              guest: guestUuid,
              keyword: settings_.keyword,
              lastevent: null, // that.lastEventId,
              infos: {
                language: settings_.ua.language,
                device: settings_.ua.device,
                browser: settings_.ua.browser,
                origin: settings_.windowUrl
              }
            }
            const ret = this.send(JSON.stringify(params))
            if (ret === true) {
              commit('updateWsIsOpen', true)
            } else {
              // console.error('CANT SEND!!')
            }
          }
          this._vm.$socket.onmessage = function (data, flags, number) {
            dispatch({
              type: 'handleMessages',
              data: data
            })
            if (getters.isAllowedToPush === true) {
              flashTitle.on(`📫 ${i18n.t('doc_title_new_msg')}`, 1000)
              const jsonData = JSON.parse(data.data)
              if (!('history' in jsonData) &&
                  'rich_content' in jsonData &&
                  jsonData.rich_content !== null &&
                  jsonData.rich_content.length > 0 &&
                  'txt' in jsonData.rich_content[0]) {
                push.create(jsonData.rich_content[0].txt)
              }
            }
          }
          this._vm.$socket.onclose = function (e) {
            // console.error('WebSocketClient: closed', arguments)
            commit('updateWsIsOpen', false)
          }
        }
      },
      sendMsg ({ commit, state }, args) {
        commit('updateCanType', false)
        const that = this
        const options = {
          whiteList: [], // empty, means filter out all tags
          stripIgnoreTag: true, // filter out all HTML not in the whilelist
          stripIgnoreTagBody: ['script'] // the script tag is a special case, we need
          // to filter out its content
        }
        let sanitized = {}
        if (typeof args.richContent === 'object') {
          for (const key in args.richContent) {
            let cleaned
            if (typeof args.richContent[key] === 'object') {
              cleaned = {}
              for (const key_ in args.richContent[key]) {
                cleaned[key_] = xss(args.richContent[key][key_], options)
              }
            } else {
              cleaned = xss(args.richContent[key], options)
            }
            sanitized[key] = cleaned
          }
        } else if (typeof args.richContent === 'string') {
          sanitized = xss(args.richContent, options)
        } else if (typeof args.richContent === 'number') {
          sanitized = args.richContent
        }
        let richContent
        if (typeof args.richContent === 'string') {
          richContent = JSON.stringify([{
            kind: 'txt',
            txt: sanitized
          }])
        } else if (args.richContent !== null) {
          richContent = JSON.stringify([sanitized])
        } else {
          richContent = null
        }
        const jString = JSON.stringify({
          headers: {
            language: navigator.language,
            timezone: new Date().getTimezoneOffset()
          },
          cmd: 'message',
          url: this._vm.$settings.windowUrl,
          content: args.content,
          rich_content: richContent
        })
        window.setTimeout(function () {
          that._vm.$socket.send(jString)
          state.isLoaderSeen = true
        }, 1000)
      }
    }
    this.mutations = {
      updateCanType (state, value) {
        state.canType = value
      },
      disablePreviousChoices (state, uuid) {
        state.messages.forEach((msg) => {
          msg.rich_content.forEach((elt) => {
            elt.disabled = true
            if (elt.kind === 'timeslots') {
              elt.timeslots.forEach((timeslot) => {
                timeslot.disabled = true
              })
            }
          })
        })
      },
      initial (state, params) {
        state.isOpen = params.is_open
        state.autoOpen = params.auto_open
      },
      setHasZenMsgButton (state, value) {
        state.hasZenMsgButton = value
      },
      spliceMessages (state, uuid) {
        let lastMsgIndex
        let found = false
        state.messages.forEach((msg, index) => {
          if (found === false && msg.msg_id === uuid) {
            lastMsgIndex = index
            found = true
          }
        })
        state.messages.splice(lastMsgIndex, state.messages.length - lastMsgIndex)
        const lastMsg = state.messages[state.messages.length - 1]
        lastMsg.rich_content.forEach((elt) => {
          elt.disabled = false
        })
      },
      toggleUpload (state) {
        state.isUpload = !state.isUpload
      },
      updateIsAllowedToPush (state, value) {
        state.isAllowedToPush = value
      },
      updateCaller (state, caller) {
        state.userInfos.caller = caller
      },
      updateEmojiPickerShown (state, value) {
        if (value === undefined) {
          value = !state.emojiPickerShown
        }
        state.emojiPickerShown = value
      },
      updateMsgs (state, data) {
        const speed = 1000
        state.isLoaderSeen = true
        let x = 0
        const loopArray = (arr) => {
          appendMsg(arr[x], () => {
            // set x to next item
            x++

            // any more items in array? continue loop
            if (x < arr.length) {
              loopArray(arr)
            } else {
              state.isLoaderSeen = false
            }
          })
        }

        const appendMsg = async (item, callback) => {
          // let created = null
          // console.log('STATE MSG', state.messages, state.messages.length)

          // if (state.messages && state.messages.length > 0) {
          //   created = dayjs(
          //     state.messages[state.messages.length - 1].created).unix()
          // }
          // const now = Date.now() / 1000
          // console.log('MSG', created, 'NOW', now, 'DIFF', now - created)
          // if (created !== null && now - created < 30000) {
          //   speed = 1000
          // }
          window.setTimeout(() => {
            // progressive display of the history
            if (item && (item.kind === 'message' ||
                item.kind === 'bot_message' ||
                item.kind === 'gbagent_message' ||
                item.kind === 'agent_msg')) {
              const msg = Object.assign({}, item)
              if (msg.rich_content === null) {
                // case of survey
                state.isLoaderSeen = false
              } else {
                // all other cases
                msg.rich_content.forEach((elt) => {
                  let inputTypeTooltip = null
                  if (elt.input_type !== undefined) {
                    inputTypeTooltip = elt.input_type
                  }
                  state.inputTypeTooltip = inputTypeTooltip
                  let helpText = null
                  if (elt.help_text !== undefined) {
                    helpText = elt.help_text
                  }
                  state.helpText = helpText
                  // console.log('>>>', item.item, msg)
                  let disabled = false
                  if (data.history !== undefined &&
                      x < data.history.length - 1) {
                    disabled = true
                  }
                  elt.disabled = disabled
                  elt.itemId = msg.uuid
                  elt.from = item.from
                })
                if (state.messages.every(message => message.msg_id !== msg.msg_id)) {
                  state.messages.push(msg)
                }
              }
            }
            if (item !== undefined) {
              state.lastEventId = item.msg_id
            }
            if (callback !== undefined) {
              callback()
            } else {
              state.isLoaderSeen = false
            }
          }, speed)
        }

        if (data.history !== undefined) {
          loopArray(data.history)
        } else {
          appendMsg(data)
        }
      },
      updateStep (state, step) {
        state.step = step
      },
      updateUserMsg (state, message) {
        state.userInfos.message = message
      },
      updateWsIsOpen (state, value) {
        state.wsIsOpen = value
      }
    }
  }
}
